const $ = kendo.jQuery

function getGridColumns(columns, isSummaryView) {
  return columns.map(element => {
    const {format, field, title} = element
    const numeric = /N/.test(format)
    const alignRight = {
      style: 'text-align: right;',
    }
    const numericAttributes = {
      attributes: {
        ...alignRight,
        ...(field === 'Total' && isSummaryView ? {class: 'totalDrillDown'} : {}),
      },
      footerAttributes: {
        ...alignRight,
      },
      footerTemplate: '#:kendo.toString(sum, "N0")#',
      groupHeaderColumnTemplate: isSummaryView
        ? `<div class="group-header ${
            field === 'Total' ? 'totalDrillDown' : ''
          }">#:kendo.toString(sum, "N0")#</div>`
        : '#=data.value#',
    }

    return {
      template: field === 'KeyName' ? '' : undefined,
      field: `["${field}"]`,
      title: title,
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: left;',
      },
      groupHeaderColumnTemplate: field === 'KeyName' ? '#=data.value#' : 'Total',
      footerAttributes: {
        style: 'text-align: left;',
      },
      footerTemplate: 'Grand Total',
      format: format,
      ...(numeric ? numericAttributes : {}),
    }
  })
}

function getGroups(columns, summaryView) {
  if (summaryView) {
    return {
      field: 'KeyName',
      aggregates: columns.map(element => {
        const {format, field} = element
        const numeric = /N/.test(format)

        return {
          field: `["${field}"]`,
          aggregate: numeric ? 'sum' : 'count',
        }
      }),
    }
  } else {
    return {
      field: 'Month',
      aggregate: 'count',
    }
  }
}

function getAggregates(columns) {
  return columns
    .filter(element => element.format != null)
    .map(({field}) => ({
      field: `["${field}"]`,
      aggregate: 'sum',
    }))
}

function renderGrid($container, options, renderLocation) {
  return new Promise(function(resolve, reject) {
    const action = renderLocation == 'report' ? 'ReadFromReport' : 'ReadFromDashboard'
    const dataSourceUrl = `/api/report/FuturePastDistributedHedge/${action}`

    $.ajax({
      url: dataSourceUrl,
      data: options,
      success: function(response) {
        const {data, columns} = response

        const grid = $container
          .empty()
          .kendoGrid({
            editable: false,
            scrollable: false,
            dataSource: {
              data: data,
              group: getGroups(columns, options.summaryView),
              aggregate: getAggregates(columns),
            },
            dataBound: function(e) {
              if (renderLocation === 'dashboard') {
                var items = e.sender.dataSource.data().length
                if (items == 0) {
                  e.sender.element.closest('.component').remove()
                }
                if (items > 25) {
                  e.sender.element.closest('.component').prepend('<div class="page-break"/>')
                }
              }

              if (e.sender.dataSource.group().length > 0) {
                $('.k-grouping-row').each(function(key, item) {
                  e.sender.collapseGroup(item)
                })
              }

              e.sender.footer.find('td').addClass('k-header')

              resolve(grid)
            },
            filterable: false,
            sortable: false,
            pageable: false,
            columns: getGridColumns(columns, options.summaryView),
          })
          .data('kendoGrid')

        if (!options.summaryView) {
          if (grid) grid.dataSource.group('')
        }
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

export default {
  render: function($container, options, location = 'dashboard') {
    return renderGrid($container, options, location)
  },
}
